import { render, staticRenderFns } from "./reports-modal.vue?vue&type=template&id=0f645d58&"
import script from "./reports-modal.vue?vue&type=script&lang=js&"
export * from "./reports-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports